import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import { ModalShell } from '../../../components/ui/ModalFrame';
import { MODAL_LAYER } from '../../../constants/modalLayers';
import { MODAL_DIALOG_ACTIONS_END } from '../../../constants/layoutSpacing';
import { cn } from '../../../utils/cn';

const AddMemberDialog = ({ isOpen, onCancel, onConfirm }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    if (!email.trim()) return;

    setLoading(true);
    setError('');

    try {
      await onConfirm(email.trim()); // parent throws on error
      setEmail('');
    } catch (err) {
      setError(err.message || 'Erro ao adicionar membro');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setEmail('');
    setError('');
    onCancel();
  };

  return (
    <ModalShell
      zClass={MODAL_LAYER.standard}
      backdropClassName="bg-black/50"
      panelClassName="bg-card rounded-lg max-w-md w-full p-6 shadow-elevation-lg"
    >
      <h2 className="text-lg font-semibold mb-2">
        Adicionar membro
      </h2>

      <p className="text-sm text-muted-foreground mb-4">
        Informe o email do usuário que terá acesso à licença.
      </p>

      <Input
        type="email"
        label="E-mail"
        placeholder="email@exemplo.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={loading}
        error={error || undefined}
      />

      <div className={cn(MODAL_DIALOG_ACTIONS_END, 'mt-6')}>
        <Button
          variant="outline"
          onClick={handleCancel}
          disabled={loading}
        >
          Cancelar
        </Button>

        <Button
          onClick={handleConfirm}
          disabled={!email.trim() || loading}
        >
          {loading ? 'Adicionando...' : 'Adicionar'}
        </Button>
      </div>
    </ModalShell>
  );
};

export default AddMemberDialog;
